module.exports = __webpack_public_path__ + "pl.9435f80be31fd33d536c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pl.svg
// module chunks = styles